import request from '@/utils/request'

let FriendsApi = {
 /*好友圈列表*/
 friendslist(data, errorback) {
  return request._post('/shop/plus.friends.friends/index', data, errorback);
},
/*添加好友圈*/
addfriends(data, errorback) {
  return request._post('/shop/plus.friends.friends/add', data, errorback);
},
/*修改好友圈*/
editfriends(data, errorback) {
  return request._post('/shop/plus.friends.friends/edit', data, errorback);
},
/*删除好友圈*/
deletefriends(data, errorback) {
  return request._post('/shop/plus.friends.friends/delete', data, errorback);
},
getFriend(data, errorback){
  return request._get('/shop/setting.friend/index', data, errorback);
},
setFriend(data, errorback){
  return request._post('/shop/setting.friend/index', data, errorback);
}
}
export default FriendsApi;



// WEBPACK FOOTER //
// ./src/api/friends.js